
<template>
  <div class="FoodCard" >
    <div class="thumbnail">
      <img class="card-img" :src="food.image" />
    </div>
    <div class="text">
      <p class=" card-brand" v-if="food.brand">{{ food.brand }}</p>

      <h3 class="card-name">{{ food.name }}</h3>
      <p class="card-calories">{{parseInt(food.caloriesPer100g, 10) }} calories</p>

      <div class="tags" v-if="type === 'add'">
        <p class="tag card-brand" v-if="food.brand">{{ food.brand }}</p>
        <p class=" tag card-category">{{ food.category }}</p>
        <!-- <p class="card-categoryLabel">{{ food.categoryLabel }}</p> -->
    </div>

    </div>
    <div class="number-input" v-if="type === 'list'">
      <label for="first" id="label">Grams</label>
      <input type="number" placeholder="0g" pattern="[0-9]*" v-model="food.grams"
        @change="calcCals(food.name, food.grams, food.caloriesPer100g)">
      <!-- <label class="amount" v-html="reversedMessage(food.grams)"></label> -->
    </div>


    <div class="hiddenButtons">

      <div class="deletebutton btn" @click="$store.commit('removeFood', food)">
        <svg width="22px" height="22px" viewBox="0 0 48 48" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns="http://www.w3.org/2000/svg">
          <defs>
            <path d="M0 0L48 0L48 48L0 48L0 0Z" id="path_1" />
          </defs>
          <g id="trace-(1)">
            <path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="#FFFFFF" fill-opacity="0" fill-rule="evenodd"
              stroke="none" />
            <path
              d="M20.3083 0.0273272C15.3001 0.251284 13.8072 1.94005 13.6619 7.54569L13.6234 9.02875L7.99684 9.02932L2.3703 9.02988L2.05956 9.17389C0.659665 9.82271 0.610286 11.7389 1.97482 12.4658L2.2573 12.6164L4.33359 12.6331L6.40988 12.6498L6.41044 25.571C6.41078 33.4944 6.43282 38.8637 6.46745 39.4527C6.79028 44.9442 8.50108 46.6301 14.0653 46.94C16.0168 47.0487 35.1563 46.9826 36.1276 46.8638C40.3207 46.351 41.8883 44.8508 42.3963 40.8652C42.5485 39.6707 42.5673 37.9947 42.5678 25.5684L42.5684 12.6446L44.5882 12.6445L46.6079 12.6445L46.9469 12.4818C48.3248 11.8202 48.3574 9.92882 47.0034 9.20751L46.7209 9.057L41.0288 9.0418L35.3367 9.02666L35.3362 7.85535C35.3337 2.02802 33.9832 0.361737 29.0089 0.0484009C28.2005 -0.00255996 21.3472 -0.0191142 20.3083 0.0273272M21.2123 3.659C17.4954 3.77985 17.3546 3.93799 17.2989 8.05412L17.2857 9.02876L24.5033 9.02871L31.7208 9.02865L31.7188 8.76028C31.6946 5.56387 31.4854 4.28285 30.9501 4.05341C30.1072 3.69211 25.6933 3.51335 21.2123 3.659M10.0268 24.3255C10.0287 43.8698 9.86078 42.7915 12.9636 43.1854C14.9097 43.4325 33.4492 43.4564 35.7733 43.2149C39.1366 42.8653 38.9276 44.0787 38.9445 24.8057L38.9552 12.6446L24.4904 12.6446L10.0257 12.6446L10.0268 24.3255M16.4947 18.2313C16.082 18.4295 15.7861 18.7289 15.5946 19.142L15.4506 19.4527L15.4501 27.9992L15.4495 36.5457L15.6117 36.8976C16.2789 38.3448 18.3972 38.2888 18.9444 36.8094L19.0654 36.4825L19.0648 27.9676L19.0642 19.4527L18.929 19.1623C18.4833 18.2049 17.4071 17.7933 16.4947 18.2313M23.7829 18.2095C23.3431 18.3891 22.9686 18.7737 22.8035 19.2148L22.6812 19.5416L22.6818 28.0565L22.6823 36.5714L22.8175 36.8618C23.4967 38.3204 25.4798 38.3325 26.1519 36.8821L26.2959 36.5714L26.2965 28.0249L26.2971 19.4784L26.1348 19.1265C25.7176 18.2216 24.7127 17.8298 23.7829 18.2095M30.9581 18.2312C30.5454 18.4294 30.2495 18.7288 30.0581 19.1419L29.9141 19.4526L29.9141 28.012L29.9141 36.5714L30.0581 36.8821C30.7156 38.3009 32.6571 38.326 33.3573 36.9249L33.5288 36.5816L33.5287 28.0171L33.5287 19.4526L33.3681 19.1136C32.9355 18.2007 31.8497 17.8032 30.9581 18.2312"
              id="Shape" fill="currentColor" fill-rule="evenodd" stroke="none" />
          </g>
        </svg>


      </div>
      <div class="editbutton btn" @click="$emit('editFoodItem',food)">

        <svg width="22px" height="22px" viewBox="0 0 48 48" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns="http://www.w3.org/2000/svg">
          <defs>
            <path d="M0 0L48 0L48 48L0 48L0 0Z" id="path_1" />
          </defs>
          <g id="svg-4">
            <path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="#FFFFFF" fill-opacity="0" fill-rule="evenodd"
              stroke="none" />
            <path
              d="M38.6816 0.0583314C37.5741 0.275703 36.2388 0.855348 35.3901 1.50745C35.1209 1.70412 33.1646 3.63973 31.0427 5.79271L27.1818 9.71568L16.241 9.74673C5.99364 9.77778 5.26908 9.79848 4.73083 9.97445C2.69172 10.6473 1.14944 12.2516 0.642249 14.2286C0.507687 14.7565 0.486986 16.6197 0.486986 28.3886C0.486986 43.4491 0.445583 42.5072 1.19084 43.9252C1.67733 44.8465 2.62961 45.7987 3.55084 46.2852C4.9689 47.0305 4.02698 46.9891 19.0875 46.9891C30.8564 46.9891 32.7195 46.9684 33.2474 46.8338C35.4625 46.2645 37.2015 44.4014 37.5948 42.1552C37.719 41.5031 37.7397 39.3191 37.75 30.8418L37.75 20.346L41.9214 16.1436C44.8197 13.2246 46.186 11.7755 46.4344 11.3615C47.8214 8.98077 47.9249 6.48621 46.7242 4.03306C46.3827 3.3292 46.1239 2.97727 45.4097 2.27342C44.3953 1.25903 43.7121 0.824297 42.439 0.379212C41.6316 0.0997373 41.3728 0.0583314 40.2342 0.0376284C39.52 0.0272801 38.8265 0.0376284 38.6816 0.0583314L38.6816 0.0583314ZM41.3832 4.3125C42.1802 4.69548 42.7289 5.22337 43.1118 5.98933C43.3602 6.49653 43.3913 6.6932 43.3913 7.55232C43.3913 9.20845 44.0538 8.45284 32.9059 19.5697C22.6896 29.7652 22.5136 29.9309 20.4849 31.0798C19.5326 31.6284 18.1145 32.2287 16.9966 32.5496C16.1064 32.8084 14.3572 33.15 14.295 33.0879C14.2743 33.0672 14.3675 32.5186 14.5021 31.8665C15.03 29.2995 16.0547 27.0016 17.6384 24.8589C18.2594 24.0102 37.0773 5.06811 37.7811 4.58162C38.8369 3.84671 40.1825 3.7432 41.3832 4.3125L41.3832 4.3125ZM19.2634 17.6134C15.2369 21.6709 14.4606 22.5715 13.2703 24.5174C11.6762 27.1362 10.6929 30.2104 10.4134 33.4916C10.3513 34.2265 10.3203 35.0546 10.3617 35.3237C10.4652 36.2449 11.0138 36.9074 11.8729 37.1558C12.3594 37.3007 15.061 37.0834 16.5101 36.7832C19.7189 36.1414 22.6067 34.8165 25.2462 32.7878C25.7741 32.3737 27.9271 30.345 30.0697 28.2127L33.9202 24.3829L33.9202 32.6428C33.9202 41.7619 33.9306 41.6481 33.2785 42.3933C32.6471 43.1076 33.7339 43.0558 19.1289 43.0558C10.0201 43.0558 5.79696 43.0248 5.58994 42.9419C5.19661 42.797 4.73082 42.352 4.56521 41.9483C4.441 41.6688 4.42029 39.3813 4.42029 28.3576C4.42029 13.8871 4.37889 14.8601 5.02064 14.2494C5.6417 13.649 5.39327 13.6697 14.6573 13.6594L23.1967 13.6594L19.2634 17.6134L19.2634 17.6134Z"
              id="Group" fill="currentColor" fill-rule="evenodd" stroke="none" />
          </g>
        </svg>
      </div>

    </div>

    <template v-if="type === 'add'">
      <button @click="addFood(food)" class="card-btn"><span class="material-symbols-rounded">
          add
        </span></button>

    </template>
  </div>
</template>

<script>
export default {
  name: 'FoodCard',
  mounted() {
    this.buttonSwipe()

    console.log(this.type)
    this.$nextTick(function () {
    this.$emit('animate', true)
  })
  },
  data() {
    return {
      calculatedCals: null
    }
  },
  props: {
    food: Object,
    type: String
  },
  methods: {
    reversedMessage(val) {
      // `this` points to the vm instance
      return val + '<span class="unit">g</span>'
    },
    calcCals(name, grams, kcal) {
      //this.showTotal = true;
      // console.log(this.$refs)
      let cal = kcal / 100;
      let val = grams * cal + ' Kcal';
      this.calculatedCals = val;
      this.$emit('amountChange', { name, grams, val })

      // this.foods[index].calculatedCals = grams * cal;
      //console.log(this.foods[index])
      //this.$refs[name][0].calculatedCals = grams * cal;

      // this.showTotal = true;
      //console.log(this.showTotal)
      //this.getTotal()
    },
  },
}
</script>

<style lang="scss" scoped>

.FoodCard {
      display: flex;
      align-items: center;
      border-radius: 14px;
      padding: 4px 8px;
      background: #ffffff;
      box-shadow: 8px 9px 31px -2px rgb(146 146 146 / 11%);
}
.text {
    font-family: Gilroy; 
    font-weight: 500;
    padding-left: 4px;
}

.thumbnail {
    object-fit: contain;
    width: auto;
    height: 100%;
}
.card-calories {color: rgb(82 82 85 / 55%);font-family: Poppins;font-size: 10px;font-weight: 400;letter-spacing: 0.3px;font-family: Sofia Pro;font-family: Gilroy;font-weight: 500;padding-top: 0px;font-family: Poppins;}

.card-brand {
    font-size: 13px;
}
.card-brand {
    /* color: var(--gray-500); */
    color: #76b76f;
}
.card-name {

  color: rgba(42,42,59,0.95);
  font-family: Gilroy;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.thumbnail {/* width: 85.71px; *//* height: 69.94px; */width: 70px;height: 70px;object-fit: contain;padding: 4px;padding-left: 0px;

  display: flex;
    align-items: center;
    img.card-img {
    height: 100%;
    object-fit: contain;
}
}

.text {
    display: flex;
    gap: 2px;
    flex-direction: column;
}


.number-input {
    font-family: Poppins;
    position: relative;
    color: var(--gray-400);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
    transition: all 0.5s ease;
    width: 48px;
    margin-left: auto;
}
  input {
    border: 1.3px solid var(--gray-300);
    border-radius: 12px;
    position: relative;
    width: 92px;
    line-height: 6ex;
    line-height: 48px;
    /* margin-left: 2em; */
    text-align: center;
    color: var(--gray-400);
    width: 100%;
    /* text-align: end; */
}
#label {
    display: none;
}



/* zinc */
:root{
    --gray-50:#fafafa ;
    --gray-100: #f4f4f5;
    --gray-200: #e4e4e7;
    --gray-300: #d4d4d8;
    --gray-400:#a1a1aa ;
    --gray-500:#71717a ;
    --gray-600: #52525b;
    --gray-700:#3f3f46;
    --gray-800:#27272a ;
    --gray-900: #18181b;
}
 
input {
  color: var(--gray-300);
  font-size: 14px;
  font-weight: 500;
}
input::placeholder {
  color: var(--gray-400);
  font-weight: 400;
    width:100%;
  text-align:center;
}

.hiddenButtons {
  transform: translateX(180%);
  transition: all 0.5s;
  position: absolute;
  right: 0;
  display: flex;
  gap: 4px;

  padding: 8px;
    border-radius: 1em;
    height: -webkit-fill-available;
    box-shadow: 0 0 82px #5a5a5a10;
    background: white;
    align-items: center;
  span.material-symbols-rounded {
    font-size: 14px;
  }

  .btn {
    padding: 0 16px;
    height: -webkit-fill-available;
    color: var(--gray-400);
    font-size: 12px;
    border-radius: 1em;
    display: flex;
    /* padding: 0px 16px; */
    flex: align;
    justify-content: center;
    align-items: center;
}
}

.tags {
    font-size: 11px;
    font-weight: 300;
    color: var(--gray-400);
    display: flex;
    gap: 6px;
    padding: 4px 0px;
}

.tag {
    background: var(--gray-100);
    color: var(--gray-400);
    padding: 4px 8px;
    border-radius: 9px;
}


.tag, .card-btn {
    filter:hue-rotate(342deg);// hue-rotate(67deg);
    opacity: 0.8;
    /* filter: saturate(0); */
    color: var(--dodger-blue-400);
    /* box-shadow: 0 0 10px var(--dodger-blue-50); */
    /* color: white; */
    background: var(--dodger-blue-100);
    filter: hue-rotate(95deg)brightness(1.05)contrast(1.01)saturate(1.4);
}

.tag {
  color: var(--dodger-blue-400);
}
button.card-btn {
    display: flex;
    border: none;
    align-items: center;
    height: 36px;
    /* justify-content: center; */
   // color: var(--gray-400);
   // background: var(--gray-100);
    border-radius: 8px;
  }
</style>

